import type { CohortDetailsState } from './types';

export const COHORT_DETAILS_DEFAULT_STATE: CohortDetailsState = {
	loading: false,
	showOptInButton: false,
};

export const SESSION_STORAGE_KEY = 'C2C.MIGRATION.ADMIN.HUB.OPT.IN.BUTTON';
